// extracted by mini-css-extract-plugin
export default {"slider_section":"styles_slider_section__VcnQs","single_slider":"styles_single_slider__-D78l","slider_content":"styles_slider_content__u9m9t","desc":"styles_desc__nL6r3"};